<template>
  <v-card elevation="0" class="mb-4" >
    <v-card-text>
        <div class="row justify-center align-center" style="min-height: 450px">
            <div class="col-md-10">

                <div class="row">
                  <!-- Información de la Orden de Producción -->
                  <div class="col-md-12" v-if="productionOrder">
                    <v-card class="pa-4 mb-4" color="grey lighten-3" elevation="0">
                      <h4 class="mb-3">Información de la Orden</h4>
                      <div class="row">
                        <div class="col-md-6 pb-0">  
                            <p class="mb-1 pt-1"><strong>Fecha Programada:</strong> {{ productionOrder.scheduled_date }}</p>
                            <p class="mb-1 pt-1"><strong>Fecha Estimada de Fin:</strong> {{ productionOrder.estimated_end_date }}</p>
                            <p class="mb-1 pt-1"><strong>Almacén Origen:</strong> {{ productionOrder.warehouse_origen ? productionOrder.warehouse_origen.name : '-' }}</p>
                            <p class="mb-1 pt-1"><strong>Almacén Destino:</strong> {{ productionOrder.warehouse_destino ? productionOrder.warehouse_destino.name : '-' }}</p>
                            <p class="mb-1 pt-1"><strong>Fórmula:</strong> {{ productionOrder.formula ? productionOrder.formula.name : '-' }}</p>
                        </div>
                    
                        <div class="col-md-6 pb-0">
                          <p class="mb-1 pt-1"><strong>Cantidad de formulas a producir:</strong> {{ productionOrder.quantity }}</p>
                          <p class="mb-1 pt-1"><strong>Cantidad producto final:</strong> {{ productionOrder.quantity_product_final }}</p>
                          <p class="mb-1 pt-1"><strong>Referencia Externa:</strong> {{ productionOrder.external_reference || '-' }}</p>
                          <p class="mb-1 pt-1"><strong>Línea de Producción:</strong> {{ productionOrder.line_production != null ? productionOrder.line_production.name : '-' }}</p>
                          <p class="mb-1 pt-1"><strong>Estado Interno:</strong> {{ productionOrder.internal_state != null ? productionOrder.internal_state.name : '-' }}</p>
                          <p class="mb-1 pt-1"><strong>Usuario Asignado:</strong> {{ productionOrder.user_assignated != null ? productionOrder.user_assignated.business_name : '-' }}</p>
                        </div>
                  
                      </div>
                    </v-card>
                  </div>

                  <div class="col-md-6">
                    <v-menu
                      ref="end_date_menu"
                      v-model="end_date_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                      :disabled="view_finish_order"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="mainItem.end_date"
                          label="Fecha de Finalización*"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          v-validate="'required'"
                          name="end_date"
                          data-vv-as="Fecha de Finalización"
                          :error-messages="errors.collect('end_date')"
                         
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="mainItem.end_date"
                        no-title
                        scrollable
                        @input="end_date_menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
           
                  <div class="col-md-6">
                    <v-text-field
                      :disabled="view_finish_order"
                      data-vv-as="Cantidad Producida Final"
                      label="Cantidad Producida Final*"
                      name="quantity_produced"
                      type="number"
                      v-model="mainItem.quantity_produced"
                      v-validate="'required|decimal|min_value:0.01'"
                      :error-messages="errors.collect('quantity_produced')"
                    ></v-text-field>
                  </div>
          
                  <div class="col-md-12">
                    <v-textarea
                     :disabled="view_finish_order"
                      data-vv-as="Observaciones"
                      label="Observaciones"
                      name="observacion_resultado"
                      v-model="mainItem.observacion_resultado"
                      rows="3"
                    ></v-textarea>
                  </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-md-12">
            <v-btn class="float-right" color="primary" small @click="handleNext"> Siguiente </v-btn>
          </div>
        </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StepInicio",
  $_veeValidate: {
    validator: "new",
  },
  props: {
    productionOrder: {
      type: Object,
      default: null,
    },
    mainItem: {
      type: Object,
      required: true,
    },
    view_finish_order: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      end_date_menu: false,
    };
  },
  methods: {
    async handleNext() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.$emit("nextStep");
      } 
    },
  },
};
</script>

<style scoped></style>
